import React, { useEffect, useMemo, useState } from "react";
import { CustomDropdown } from "../SpotOrders/spotOrderUi";
import SoMobileFilters from "./SoMobileFilters";
import OrdersSubTabs from "./OrdersSubTabs";
import OrderMobileCardShell from "./OrderMobileCardShell";
import { referralCoinMatchesPair } from "./orderFilterHelpers";
import "./Referral.css";

const ORDER_DESKTOP_COL_COUNT = 7;

const TYPE_OPTIONS = [
  { value: "commission", label: "Commission Rebate" },
  { value: "bonus", label: "Bonus" },
];

const ACCOUNT_OPTIONS = [
  { value: "all", label: "All Accounts" },
  { value: "spot", label: "Spot" },
  { value: "futures", label: "Futures" },
];

const COIN_OPTIONS = [
  { value: "all", label: "All" },
  { value: "btc", label: "BTC" },
  { value: "eth", label: "ETH" },
  { value: "bnb", label: "BNB" },
];

/*
const ROWS = [
  {
    id: 1,
    date: "2026-04-20 15:30",
    pair: "BTC ↔ USDT",
    payAmount: "0.015 BTC",
    getAmount: "1,245.50 USDT",
    fee: "2.49 USDT",
    rate: "1 BTC = 83,033.33 USDT",
    status: "Completed",
    rebateType: "commission",
    account: "spot",
  },
  {
    id: 2,
    date: "2026-04-20 11:15",
    pair: "ETH ↔ USDT",
    payAmount: "2.5 ETH",
    getAmount: "6,750.00 USDT",
    fee: "13.50 USDT",
    rate: "1 ETH = 2,700.00 USDT",
    status: "Completed",
    rebateType: "commission",
    account: "futures",
  },
  {
    id: 3,
    date: "2026-04-19 16:45",
    pair: "BNB ↔ USDT",
    payAmount: "15 BNB",
    getAmount: "9,000.00 USDT",
    fee: "18.00 USDT",
    rate: "1 BNB = 600.00 USDT",
    status: "Completed",
    rebateType: "bonus",
    account: "spot",
  },
];
*/
const ROWS = [];

const Referral = () => {
  const [type, setType] = useState("commission");
  const [account, setAccount] = useState("all");
  const [coin, setCoin] = useState("all");
  const [typeDraft, setTypeDraft] = useState("commission");
  const [accountDraft, setAccountDraft] = useState("all");
  const [coinDraft, setCoinDraft] = useState("all");
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    if (!openDropdown) return undefined;
    const onDocClick = (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (!t.closest("[data-so-dropdown]")) setOpenDropdown(null);
    };
    document.addEventListener("click", onDocClick, true);
    return () => document.removeEventListener("click", onDocClick, true);
  }, [openDropdown]);

  useEffect(() => {
    if (!openDropdown) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setOpenDropdown(null);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [openDropdown]);

  const renderEmptyBody = () => (
    <tr>
      <td colSpan={ORDER_DESKTOP_COL_COUNT} className="so-table__emptyWrap">
        <div className="so-emptyState" role="status">
          <img src="/images/no-data.svg" alt="" width={120} height={144} className="so-emptyState__img" />
        </div>
      </td>
    </tr>
  );

  const filteredRows = useMemo(() => {
    return ROWS.filter((r) => {
      if (type && r.rebateType && r.rebateType !== type) return false;
      if (account && account !== "all" && r.account && r.account !== account) return false;
      if (!referralCoinMatchesPair(r.pair, coin)) return false;
      return true;
    });
  }, [type, account, coin]);

  const resetFilters = () => {
    setType("commission");
    setAccount("all");
    setCoin("all");
    setTypeDraft("commission");
    setAccountDraft("all");
    setCoinDraft("all");
  };

  const applyMobileFilters = () => {
    setType(typeDraft);
    setAccount(accountDraft);
    setCoin(coinDraft);
  };

  const renderToolbar = (stacked, keyPrefix) => {
    const pref = keyPrefix ? `${keyPrefix}-` : "";
    const isMob = keyPrefix === "mob";
    const tp = isMob ? typeDraft : type;
    const ac = isMob ? accountDraft : account;
    const cn = isMob ? coinDraft : coin;
    const setTp = isMob ? setTypeDraft : setType;
    const setAc = isMob ? setAccountDraft : setAccount;
    const setCn = isMob ? setCoinDraft : setCoin;
    return (
      <div className={`so-toolbar ${stacked ? "so-toolbar--stack" : ""}`} role="search" aria-label="Filter referrals">
        <div className="so-toolbar__left">
          <CustomDropdown
            id={`${pref}ref-dd-type`}
            label="Type"
            value={tp}
            options={TYPE_OPTIONS}
            onChange={setTp}
            menuKey={`${pref}ref-type`}
            openKey={openDropdown}
            onOpenToggle={setOpenDropdown}
          />
          <CustomDropdown
            id={`${pref}ref-dd-account`}
            label="Account"
            value={ac}
            options={ACCOUNT_OPTIONS}
            onChange={setAc}
            menuKey={`${pref}ref-account`}
            openKey={openDropdown}
            onOpenToggle={setOpenDropdown}
          />
          <CustomDropdown
            id={`${pref}ref-dd-coin`}
            label="Coin"
            value={cn}
            options={COIN_OPTIONS}
            onChange={setCn}
            menuKey={`${pref}ref-coin`}
            openKey={openDropdown}
            onOpenToggle={setOpenDropdown}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="dashboard_right">
      <div className="dashboard_listing_section2 Overview_mid">
        <div className="listing_left_outer full_width transaction_history_t desktop_view2 so-desktopWrap">
          <main className="so-page" aria-labelledby="so-referral-title">
            <h1 id="so-referral-title" className="so-page__title">
              Referral
            </h1>

            <OrdersSubTabs
              tabs={[
                { label: "Deposit", to: "/user_profile/orders/deposit_history" },
                { label: "Withdraw", to: "/user_profile/orders/withdraw_history" },
                { label: "Transfer", to: "/user_profile/orders/transfer" },
                { label: "Referral", to: "/user_profile/orders/referral" },
              ]}
            />

            {renderToolbar(false, "desk")}

            <div className="so-tableWrap ">
              <table className="so-table so-table--air">
                <thead>
                  <tr>
                    <th scope="col">Date</th>
                    <th scope="col">Swapping Currencies</th>
                    <th scope="col">
                      Pay Amount
                    </th>
                    <th scope="col">Get Amount</th>
                    <th scope="col">
                      Swapping Fee
                    </th>
                    <th scope="col">Conversion Rate</th>
                    <th scope="col">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRows.length === 0
                    ? renderEmptyBody()
                    : filteredRows.map((r) => (
                      <tr key={r.id}>
                        <td className="so-num">{r.date}</td>
                        <td>{r.pair}</td>
                        <td className="so-num">{r.payAmount}</td>
                        <td className="so-fillQty--pos so-num"><div className="amountgreen">{r.getAmount}</div></td>
                        <td>{r.fee}</td>
                        <td className="so-num">{r.rate}</td>
                        <td>
                          <span className="so-status so-status--completed">{r.status}</span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </main>
        </div>

        <div className="order_history_mobile_view so-mobile">
          <h2 className="so-mobile__title">Referral</h2>
          <OrdersSubTabs
            tabs={[
              { label: "Deposit", to: "/user_profile/orders/deposit_history" },
              { label: "Withdraw", to: "/user_profile/orders/withdraw_history" },
              { label: "Transfer", to: "/user_profile/orders/transfer" },
              { label: "Referral", to: "/user_profile/orders/referral" },
            ]}
          />
          <div className="so-mobile__toolbar">
            <SoMobileFilters
              modalId="mob-referral-filters"
              toolbar={renderToolbar(true, "mob")}
              onSearch={applyMobileFilters}
              onReset={resetFilters}
            />
          </div>
          {filteredRows.length === 0 ? (
            <div className="so-emptyState so-emptyState--mobile" role="status">
              <img src="/images/no-data.svg" alt="" width={120} height={144} className="so-emptyState__img" />
            </div>
          ) : (
            filteredRows.map((r) => (
              <OrderMobileCardShell key={`m-${r.id}`} desktopColumnCount={ORDER_DESKTOP_COL_COUNT} popupTitle="Referral details">
                <div className="so-mobileCard__row">
                  <span>Date</span>
                  <span className="so-num">{r.date}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Pair</span>
                  <span>{r.pair}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Pay</span>
                  <span className="so-num">{r.payAmount}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Get</span>
                  <span className="so-num">{r.getAmount}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Fee</span>
                  <span className="so-num">{r.fee}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Rate</span>
                  <span className="so-num">{r.rate}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Status</span>
                  <span className="so-status so-status--completed">{r.status}</span>
                </div>
              </OrderMobileCardShell>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Referral;

